import { BaseService } from './BaseService';
import { API_ENDPOINTS } from './config';

export interface Role {
  value: string;
  description: string;
}

export interface RolesResponse {
  success: boolean;
  roles: Role[];
}

export class RoleService extends BaseService {
  /**
   * Get all available roles
   */
  static async getAll(): Promise<Role[]> {
    try {
      const response = await this.get<RolesResponse>(API_ENDPOINTS.ROLES.BASE);
      return response.roles || [];
    } catch (error) {
      console.error('[RoleService] Error fetching roles:', error);
      return [];
    }
  }
}

